export default __webpack_public_path__ + "dist/assets/sounds/point-reached.0821bac4.mp3";